export default __webpack_public_path__ + "72149d98bb3fd0925dcb4bae001e4e53.png";